import { useEffect, useState } from "react";
import { useFormState } from "react-hook-form";
import useLocale from "../../../hooks/useLocale";
import getInvalidLocales from "../../../libraries/utils/reactHookForm/getInvalidLocales";

/**
 * A component that exposes invalid locales of a form via a render function
 *
 * @param {{
 * render: ({ invalidLocales } : { invalidLocales: string[]}) => React.ReactNode,
 * }} param0
 * @returns
 */
function InvalidLocalesRHF({ render }) {
  const { defaultLocale, locales } = useLocale();

  const [invalidLocales, setInvalidLocales] = useState([]);

  const formState = useFormState();

  useEffect(() => {
    const newInvalidLocales = getInvalidLocales(
      formState.errors,
      defaultLocale,
      locales,
    );
    setInvalidLocales((prevInvalidLocales) => {
      if (
        prevInvalidLocales.length === newInvalidLocales.length &&
        prevInvalidLocales.every((v, i) => v === newInvalidLocales[i])
      ) {
        return prevInvalidLocales;
      }
      return newInvalidLocales;
    });
  }, [defaultLocale, formState, locales]);

  return <>{render?.({ invalidLocales })}</>;
}

export default InvalidLocalesRHF;
